import { useForm } from '@mantine/form';
import { useState } from 'react';
import { validateNumber } from '../../../util/validation/commonValidation';
import type { UpsertPrescriptionDto } from '../types/PrescriptionDto';

const defaultPrescription: UpsertPrescriptionDto = {
	pkid: 0,
	branchId: '',
};

const MAX_COUNT = 1_000_000;

const validateCount =
	(propertyDescription: string) => (value: number | undefined) =>
		validateNumber(
			value?.toString(),
			true,
			0,
			MAX_COUNT,
			propertyDescription,
			false,
		);

export function useUpsertPrescriptionForm(
	prescription: UpsertPrescriptionDto = defaultPrescription,
) {
	const [inputs, setInputs] = useState<UpsertPrescriptionDto>(prescription);

	const form = useForm<UpsertPrescriptionDto>({
		mode: 'uncontrolled',
		initialValues: prescription,
		validate: {
			branchId: (value) =>
				!value || value.length < 1 ? 'A branch must be selected' : null,
			dateTime: (value) => (!value ? 'A date must be selected' : null),
			forms: validateCount('Forms'),
			items: validateCount('Items'),
			dailyInstallments: validateCount('Daily Installments'),
			weeklyInstallments: validateCount('Weekly Installments'),
			pfsForms: validateCount('PFS Forms'),
			pfsItems: validateCount('PFS Items'),
			pgsReferrals: validateCount('PFS Referrals'),
			pfsConsultations: validateCount('PFS Advice'),
			serialRxItems: validateCount('Serial Rx Items'),
			gp10aForms: validateCount('GP10a Forms'),
			gp10aItems: validateCount('GP10a Items'),
			otherCp4: validateCount('Other CP4'),
			methadone: validateCount('Methadone Patients No'),
		},
		onValuesChange: (v) => setInputs(v),
	});

	return { form, inputs };
}
